import { render, staticRenderFns } from "./sell-course.vue?vue&type=template&id=d18678a0&scoped=true"
import script from "./sell-course.vue?vue&type=script&lang=js"
export * from "./sell-course.vue?vue&type=script&lang=js"
import style0 from "./sell-course.vue?vue&type=style&index=0&id=d18678a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18678a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d18678a0')) {
      api.createRecord('d18678a0', component.options)
    } else {
      api.reload('d18678a0', component.options)
    }
    module.hot.accept("./sell-course.vue?vue&type=template&id=d18678a0&scoped=true", function () {
      api.rerender('d18678a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/sell-course.vue"
export default component.exports